import { Answer } from "./Answer";
import { QuestionIllustration } from "./QuestionIllustration";
import { QuizCountry } from "./QuizCountry";

export class Question
{
    private questionText: string;
    private answers: Array<Answer> = [];
    private _id: string;

    constructor(questionText: string, answers: Array<Answer>, private _illustration: QuestionIllustration, private _quizCountry: QuizCountry)
    {
        this.questionText = questionText;
        this.answers = answers;
        this._id = this.questionText.replace(/[\n\r]+|[\s]{2,}/g, ' ');
    }

    public getQuestionText(): string
    {
        return this.questionText;
    }

    public getAnswers(): Array<Answer>
    {
        return this.answers;
    }

    public setQuizCountry(country: QuizCountry): void { this._quizCountry = country; }
    public getQuizCountry(): QuizCountry
    {
        return this._quizCountry;
    }

    public get id(): string 
    {
        return this._id;
    }

    public get quizCountryClassName(): string 
    {
        let countryName = QuizCountry[this.getQuizCountry()].toLowerCase();
        return "country-" + countryName;
    }

    public get quizIllustrationClassName(): string 
    {
        let questionIllustration = QuestionIllustration[this._illustration].toLowerCase();
        return "quiz-" + questionIllustration;
    }
}